import { ZIPCODE_ERROR_VALIDATION_MSG, ZIPCODE_REGEX } from '../constants/address';
import { RequestOptions } from '../types/httpRequests';
import { Address } from '../types/orderTypes';

const backendURL = process.env.REACT_APP_BACKEND_URL;

export async function validatePhoneNumber(phoneNumber: string) {
  try {
    const response = await fetch(`${backendURL}/validations/phone-number`, {
      method: 'POST',
      body: JSON.stringify({ phone_number: phoneNumber }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    });

    const responseBody = await response.json();
    return responseBody.is_valid;
  } catch (error) {
    console.error('Error validating phone number', error);
    return false;
  }
}

export default async function validateAddress(addressData: Address, apiFetchRequest: any) {
  try {
    const endpointUrl: string = `${backendURL}/validations/address`;
    const apiRequestOptions: RequestOptions = {
      method: 'POST',
      endpoint: endpointUrl,
      body: {
        address_1: addressData.address1,
        address_2: addressData.address2,
        city: addressData.city,
        state: addressData.state,
        zipcode: addressData.zipcode,
      },
    };

    const response = await apiFetchRequest(apiRequestOptions);

    if (response.status === 200) {
      return 'VALID';
    } else {
      const errorMessage = `Address validation failed with status: ${response.body.status}`;
      console.error(errorMessage);
      // here, it would be the right place to handle the 429 status code error
      // which is about the rate limit exceeded
      // probably running a callback function to notify the user
      // and click on a button to try again
      return response.body.status;
    }
  } catch (error) {
    console.error('Error validating address:', error);
    return 'NOT_VALID';
  }
}

export const validateZipcode = (value: string) => {
  if (!value) {
    return 'Zipcode is required';
  }
  if (!ZIPCODE_REGEX.test(value)) {
    return ZIPCODE_ERROR_VALIDATION_MSG;
  }
  return;
};
